module.exports = __webpack_public_path__ + "sx.svg?89f96e7884f6dbcbb0496360d3937c34";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/sx.svg
// module id = 1630
// module chunks = 0